<script lang="ts">
    import { writable } from "svelte/store";
    import { AvailabilityStatus } from "@workadventure/messages";
    import { availabilityStatusStore, selectDefaultSpeaker, speakerSelectedStore } from "../../../Stores/MediaStore";
    import type { VideoBox } from "../../../Space/VideoBox";
    import AudioStream from "./AudioStream.svelte";

    interface Props {
        videoBox: VideoBox;
    }

    let { videoBox }: Props = $props();
    let streamable = $derived(videoBox.streamable);

    let muteAudioStore = $derived($streamable?.muteAudio);
    let muteAudio = $derived($muteAudioStore ?? false);

    let hasAudio = $derived($streamable?.hasAudio ?? writable(false));

    // Outside a room, these statuses keep the user out of proximity bubbles entirely, so there's
    // no incoming audio to begin with. Inside a LiveKit room, membership is driven by area entry
    // (see AreasPropertiesListener.handleLivekitRoomPropertyOnEnter), not by status, so without
    // this the user would still hear others while "deafened" everywhere else - mirrors the
    // isUnavailableStatus set MediaStore.ts uses to mute the outgoing microphone for these statuses.
    let isDeafened = $derived(
        $availabilityStatusStore === AvailabilityStatus.DENY_PROXIMITY_MEETING ||
            $availabilityStatusStore === AvailabilityStatus.SILENT ||
            $availabilityStatusStore === AvailabilityStatus.DO_NOT_DISTURB ||
            $availabilityStatusStore === AvailabilityStatus.BACK_IN_A_MOMENT ||
            $availabilityStatusStore === AvailabilityStatus.SOUND_BLOCKED ||
            $availabilityStatusStore === AvailabilityStatus.BUSY,
    );
</script>

{#if $streamable && ($streamable?.media.type === "webrtc" || $streamable?.media.type === "livekit") && !muteAudio && !isDeafened && $hasAudio}
    <AudioStream
        streamStore={$streamable.media.streamStore}
        volume={$streamable.volume}
        outputDeviceId={$speakerSelectedStore}
        isBlocked={$streamable.media.isBlocked}
        onselectoutputaudiodeviceerror={() => selectDefaultSpeaker()}
    />
{/if}
